"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Item;

var _react = _interopRequireWildcard(require("react"));

var _reactSound = _interopRequireDefault(require("react-sound"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ItemModule = _interopRequireDefault(require("./Item.module.scss"));

var _tooltips = require("../../tooltips");

var _assets = require("../../../assets");

var _MouseTooltipContext = _interopRequireDefault(require("../../tooltips/MouseTooltipContext/MouseTooltipContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ICON_WIDTH_UNIT_IN_PX = 32;
var ICON_HEIGHT_UNIT_IN_PX = 32;
var ITEM_ICONS = "".concat(_assets.ASSETS_ITEMS, "/icons/");
var DRAG_SOUNDS = "".concat(_assets.ASSETS_ITEMS, "/dragSounds/");
var ESoundStatus;

(function (ESoundStatus) {
  ESoundStatus["PLAYING"] = "PLAYING";
  ESoundStatus["STOPPED"] = "STOPPED";
  ESoundStatus["PAUSED"] = "PAUSED";
})(ESoundStatus || (ESoundStatus = {}));

function Item(_ref) {
  var item = _ref.item,
      viewingCharacter = _ref.viewingCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var model = item.model,
      glowing = item.glowing,
      stackSize = item.stackSize;
  var itemType = model.itemType,
      iconFileName = model.iconFileName,
      iconSizeX = model.iconSizeX,
      iconSizeY = model.iconSizeY,
      soundDragFileName = model.soundDragFileName;
  var category = itemType.category;

  var _useContext = (0, _react.useContext)(_MouseTooltipContext.default),
      setContent = _useContext.setContent,
      show = _useContext.show,
      hide = _useContext.hide;

  var _useState = (0, _react.useState)(ESoundStatus.STOPPED),
      _useState2 = _slicedToArray(_useState, 2),
      dragSoundStatus = _useState2[0],
      setDragSoundStatus = _useState2[1];

  var img = "".concat(ITEM_ICONS, "/").concat(category.id, "/").concat(itemType.id, "/").concat(glowing ? "glow_".concat(glowing.toLowerCase(), "/") : "").concat(iconFileName);
  var dragSound = "".concat(DRAG_SOUNDS).concat(soundDragFileName);
  var iconStyle = {
    width: "".concat(ICON_WIDTH_UNIT_IN_PX * iconSizeX, "px"),
    height: "".concat(ICON_HEIGHT_UNIT_IN_PX * iconSizeY, "px"),
    backgroundImage: "url(".concat(img, ")")
  };
  var handleOnMouseEnter = (0, _react.useCallback)(function () {
    hide();
    setContent( /*#__PURE__*/_react.default.createElement(_tooltips.EntityTooltipContent, {
      entity: item,
      entityType: "item",
      viewingCharacter: viewingCharacter
    }));
    show();
  }, [hide, item, setContent, show, viewingCharacter]);
  var handleOnMouseLeave = (0, _react.useCallback)(function () {
    hide();
    setContent(undefined);
  }, [hide, setContent]);
  var handleClick = (0, _react.useCallback)(function () {
    setDragSoundStatus(ESoundStatus.PLAYING);
  }, [setDragSoundStatus]);
  var handleDragSoundFinished = (0, _react.useCallback)(function () {
    setDragSoundStatus(ESoundStatus.STOPPED);
  }, [setDragSoundStatus]);
  return /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
    onClick: handleClick,
    className: (0, _classnames.default)(_ItemModule.default.item, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_reactSound.default, {
    url: dragSound,
    playStatus: dragSoundStatus,
    onFinishedPlaying: handleDragSoundFinished
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _ItemModule.default.icon,
    style: iconStyle
  }), stackSize > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: _ItemModule.default.stackSize
  }, stackSize));
}